import React, { useState, useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';
import PageHeader from '../components/ui/PageHeader';
import api from '../services/api';

const FILTERS = ['Tous', 'Finance', 'RH', 'Projets', 'Admin'];

function RapportsPage() {
  const [filter, setFilter] = useState('Tous');
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.tasks.getAll()
      .then(res => setTasks(res.tasks || []))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const reports = tasks.map(t => ({
    id: t.id,
    title: t.titre || t.title || '—',
    category: t.category || t.categorie || 'Admin',
    date: t.deadline
      ? new Date(t.deadline).toLocaleDateString('fr-FR')
      : new Date(t.created_at || Date.now()).toLocaleDateString('fr-FR'),
    status: t.done ? 'Publié' : t.priority === 'urgente' ? 'En cours' : 'Brouillon',
  }));

  const visible = filter === 'Tous' ? reports : reports.filter(r => r.category === filter);

  return (
    <MainLayout>
      <div style={{ display: 'grid', gap: 24 }}>
        <PageHeader title="Rapports" subtitle="Gestion des rapports métiers et financiers." />

        {loading && <div style={{ textAlign: 'center', color: '#C9A84C', padding: 20 }}>Chargement…</div>}
        {error && <div style={{ color: '#ef8080', fontSize: 12, padding: '8px 14px', background: 'rgba(239,83,80,.1)', borderRadius: 8 }}>⚠️ {error}</div>}

        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {FILTERS.map(label => (
            <button key={label} onClick={() => setFilter(label)}
              style={{ padding: '10px 16px', borderRadius: 999, border: '1px solid rgba(255,255,255,.12)', background: filter === label ? '#C9A84C' : 'transparent', color: filter === label ? '#0f1724' : '#dbe2ef', cursor: 'pointer', fontSize: 13 }}>
              {label}
            </button>
          ))}
        </div>

        <div style={{ background: '#0f1724', border: '1px solid rgba(255,255,255,.08)', borderRadius: 18, padding: 20 }}>
          {!loading && visible.length === 0 && (
            <div style={{ textAlign: 'center', color: '#445', padding: 20, fontSize: 13 }}>Aucun rapport trouvé.</div>
          )}
          <div style={{ display: 'grid', gap: 14 }}>
            {visible.map(r => (
              <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 16, background: '#111f2b', borderRadius: 16, padding: 18, alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 700 }}>{r.title}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>{r.category} • {r.date}</div>
                </div>
                <div style={{ fontSize: 11, color: r.status === 'Publié' ? '#66bb6a' : r.status === 'En cours' ? '#ffb74d' : '#42a5f5', whiteSpace: 'nowrap' }}>
                  {r.status}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default RapportsPage;
